import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ccbd10c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-info" }
const _hoisted_2 = { class: "stock-code" }
const _hoisted_3 = { class: "stock-name" }
const _hoisted_4 = {
  key: 0,
  class: "delay-tag"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "RiseandFallarrow"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "RiseandFallarrow"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChipSituationTrend = _resolveComponent("ChipSituationTrend")!
  const _component_ChipDistributionAnalysis = _resolveComponent("ChipDistributionAnalysis")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["chip-situation", [_ctx.theme]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.displayCode), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.displayName), 1),
      (_ctx.isDelayHK)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "延"))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        class: _normalizeClass(["stock-price", [_ctx.stockInfo.riseAndFall > 0 ? 'red' : _ctx.stockInfo.riseAndFall < 0 ? 'green' : '']])
      }, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.displayLastPrice), 1),
        (!_ctx.stockInfo.isSuspended)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              (_ctx.theme === 'dark')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    (_ctx.stockInfo.riseAndFall > 0)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: require('@/assets/top_light.png'),
                          alt: ""
                        }, null, 8, _hoisted_7))
                      : (_ctx.stockInfo.riseAndFall < 0)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: require('@/assets/bottom_dark.png'),
                            alt: ""
                          }, null, 8, _hoisted_8))
                        : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    (_ctx.stockInfo.riseAndFall > 0)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: require('@/assets/top_light.png'),
                          alt: ""
                        }, null, 8, _hoisted_10))
                      : (_ctx.stockInfo.riseAndFall < 0)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: require('@/assets/bottom_light.png'),
                            alt: ""
                          }, null, 8, _hoisted_11))
                        : _createCommentVNode("", true)
                  ]))
            ]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("span", {
        class: _normalizeClass(["stock-change", [_ctx.stockInfo.riseAndFall > 0 ? 'red' : _ctx.stockInfo.riseAndFall < 0 ? 'green' : '']])
      }, _toDisplayString(_ctx.getFormattedChange(_ctx.stockInfo.riseAndFall)), 3),
      _createElementVNode("span", {
        class: _normalizeClass(["stock-increase", [_ctx.stockInfo.increase > 0 ? 'red' : _ctx.stockInfo.increase < 0 ? 'green' : '']])
      }, _toDisplayString(_ctx.getFormattedChangePercent(_ctx.stockInfo.increase)), 3)
    ]),
    _createVNode(_component_ChipSituationTrend, {
      situationData: _ctx.situationData,
      theme: _ctx.theme
    }, null, 8, ["situationData", "theme"]),
    _createVNode(_component_ChipDistributionAnalysis, {
      jzdData: _ctx.jzdData,
      theme: _ctx.theme
    }, null, 8, ["jzdData", "theme"])
  ], 2))
}